<template>
  <Fragment>
    <template v-if="$route.name !== 'marketingIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="top">
            <div class="search-name mr-25">
              <span>订单编码：</span>
              <el-input v-model="orderCode" width="500" clearable> </el-input>
            </div>
            <el-button type="primary" class="ml-20" @click="check"
              >查验修复</el-button
            >
          </div>
          <div v-if="[null, 'null'].includes(codeData)" class="total-text">
            {{ totalMsg }}
          </div>
          <div v-if="['3', '4', '5'].includes(codeData)" class="total-text">
            生码状态：type {{ codeData }}
          </div>
          <div
            v-if="!['3', '5', null, 'null', ''].includes(codeData)"
            class="total-text"
          >
            error信息：{{ totalMsg }}
          </div>
        </section>
      </div>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "marketingIndex",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      totalMsg: "",
      orderCode: "",
      codeData: ""
    };
  },
  methods: {
    check() {
      let _this = this;
      if (!this.orderCode) {
        _this.$message({
          message: "订单编码不能为空!",
          type: "error"
        });
        return;
      } else {
        this.getCheckCode();
      }
    },
    getCheckCode() {
      let _this = this;
      let param = {
        url: "/api/repeatedCodeProess/updateLshByOrderCode",
        params: {
          orderCode: _this.orderCode
        }
      };
      _this.$store
        .dispatch("getCheckCode", param)
        .then(() => {
          _this.$message.success("修复成功");
          _this.totalMsg = _this.$store.state.generatedCode.msg;
          _this.codeData = _this.$store.state.generatedCode.data;
        })
        .catch(err => {
          console.log(err);
          if (+err.data.status === 500) {
            _this.codeData = err.data.data;
            _this.totalMsg = err.data.msg;
          }
        });
    }
  }
};
</script>

<style lang="sass" scoped>
.card-content
    display: flex
    flex-direction: column
    justify-content: center

    .top
        display: flex
        align-items: center

        .search-name
            white-space: nowrap
            display: flex
            align-items: center

    .total-text
        margin-top: 50px
</style>
